import React from "react";
import classNames from "classnames";
import { getString, StringKey } from "./strings";
import { Language } from "../core";

interface ActionLabelProps {
  stringKey: StringKey;
  forStates: string[];
  language: Language;
}
export class ActionLabel extends React.Component<ActionLabelProps> {
  private textPathRef = React.createRef<SVGTextPathElement>();

  render() {
    let { stringKey, forStates, language } = this.props;
    return (
      <div
        className={classNames(
          "actionLabel",
          forStates.map(s => `actionLabel--${s}`)
        )}
      >
        <svg width="140" viewBox="0 0 160 90">
          <path
            id="curve"
            d="M0,0A80,80,0,0,0,80,80,80,80,0,0,0,160,0"
            fill="transparent"
          />
          <text width="1000" fontSize="14px" fill="blue">
            <textPath
              ref={this.textPathRef}
              textAnchor="middle"
              startOffset="50%"
              alignmentBaseline="baseline"
              xlinkHref="#curve"
            >
              {getString(language, stringKey)}
            </textPath>
          </text>
        </svg>
      </div>
    );
  }
}
